export default __webpack_public_path__ + "static/media/Savant's Bracers of the Burning Disc.59d77ccc.jpg";